import React from "react";
import PyCell from "../../components/PyCell";

export default function SoftdataExamples() {
  const exCleanEncode = `
import pandas as pd
import numpy as np

data = {
    "age": [22, 35, np.nan, 44, 52],
    "income": [35000, 72000, 54000, None, 120000],
    "city": ["Pune", "mumbai", "Mumbai", "Delhi", None],
    "label": [0, 1, 0, 1, 1],
}
df = pd.DataFrame(data)
print("Raw:"); print(df)

# --- simple cleaning ---
df["age"] = df["age"].fillna(df["age"].median())
df["income"] = df["income"].fillna(df["income"].median())
df["city"] = df["city"].fillna("Unknown").str.title()

# one-hot encode city
df = pd.get_dummies(df, columns=["city"], prefix="city")

print("\\nCleaned + Encoded:")
print(df)
`;

  const exCleanEncodeOut = `Raw:
    age    income    city  label
0  22.0   35000.0    Pune      0
1  35.0   72000.0  mumbai      1
2   NaN   54000.0   Mumbai      0
3  44.0       NaN   Delhi      1
4  52.0  120000.0    None      1

Cleaned + Encoded:
   age    income  label  city_Delhi  city_Mumbai  city_Pune  city_Unknown
0   22   35000.0      0           0            0          1             0
1   35   72000.0      1           0            1          0             0
2   35   54000.0      0           0            1          0             0
3   44   54000.0      1           1            0          0             0
4   52  120000.0      1           0            0          0             1`;

  const exSplit = `
import pandas as pd
from math import ceil

df = pd.DataFrame({
  "age":[22,35,35,44,52],
  "income":[35000,72000,54000,54000,120000],
  "label":[0,1,0,1,1],
  "city_Delhi":[0,0,0,1,0],
  "city_Mumbai":[0,1,1,0,0],
  "city_Pune":[1,0,0,0,0],
  "city_Unknown":[0,0,0,0,1],
})

n = len(df); n_tr = ceil(n*0.6)
train = df.iloc[:n_tr]; test = df.iloc[n_tr:]
print("Train:"); print(train)
print("\\nTest:"); print(test)
`;

  const exSplitOut = `Train:
   age  income  label  city_Delhi  city_Mumbai  city_Pune  city_Unknown
0   22   35000      0           0            0          1             0
1   35   72000      1           0            1          0             0
2   35   54000      0           0            1          0             0

Test:
   age  income  label  city_Delhi  city_Mumbai  city_Pune  city_Unknown
3   44   54000      1           1            0          0             0
4   52  120000      1           0            0          0             1`;

  const exPlot = `
import matplotlib.pyplot as plt
import numpy as np

x = np.linspace(0, 2*np.pi, 200)
plt.plot(x, np.sin(x), label="sin(x)")
plt.xlabel("x"); plt.ylabel("y"); plt.title("Quick Plot"); plt.legend()
__stt_emit_png()
`;

  const exPreprocessScale = `
import pandas as pd
import numpy as np
from sklearn.preprocessing import StandardScaler

df = pd.DataFrame({
    "age": [22, 35, np.nan, 44, 52],
    "income": [35000, 72000, 54000, None, 120000],
    "city": ["Pune", "mumbai", "Mumbai", "Delhi", None],
})

df["age"] = df["age"].fillna(df["age"].median())
df["income"] = df["income"].fillna(df["income"].median())
df["city"] = df["city"].fillna("Unknown").str.title()
encoded = pd.get_dummies(df["city"], prefix="city")
X = pd.concat([df[["age","income"]], encoded], axis=1)

scaler = StandardScaler()
X[["age","income"]] = scaler.fit_transform(X[["age","income"]])

print("Final feature matrix:")
print(X)
`;

  const exPreprocessScaleOut = `Final feature matrix:
        age    income  city_Delhi  city_Mumbai  city_Pune  city_Unknown
0 -1.414214 -1.183216           0            0          1             0
1 -0.141421  0.169031           0            1          0             0
2 -0.141421 -0.507093           0            1          0             0
3  0.707107 -0.507093           1            0          0             0
4  0.989949  2.028372           0            0          0             1`;

  return (
    <main className="docs-wrap">
      <div className="docs-layout">
        <aside className="docs-toc">
          <strong>On this page</strong>
          <a href="#intro">Intro</a>
          <a href="#clean">Clean & Encode</a>
          <a href="#split">Split</a>
          <a href="#plot">Plot</a>
          <a href="#scale">Impute • One-hot • Scale</a>
        </aside>

        <article>
          <header className="stt-hero">
            <div className="stt-pill">softdata • Examples</div>
            <h1 className="stt-h1">Tidy data in your browser</h1>
            <p className="stt-lead">Run the cells below—no install needed.</p>
          </header>

          <section id="intro" className="stt-section">
            <p className="stt-p">
              These cells use <strong>Pyodide</strong> to run Python entirely in the browser.
              For plots, call <code>__stt_emit_png()</code> after you draw with Matplotlib.
            </p>
          </section>

          <section id="clean" className="stt-section">
            <h2 className="stt-h2">Clean & Encode</h2>
            <PyCell code={exCleanEncode} />
            <div className="stt-output"><pre>{exCleanEncodeOut}</pre></div>
          </section>

          <section id="split" className="stt-section">
            <h2 className="stt-h2">Train/Test Split</h2>
            <PyCell code={exSplit} />
            <div className="stt-output"><pre>{exSplitOut}</pre></div>
          </section>

          <section id="plot" className="stt-section">
            <h2 className="stt-h2">Quick Plot</h2>
            <PyCell code={exPlot} />
            <div className="stt-output">
              <em>[Plot of sin(x) will render here]</em>
            </div>
          </section>

          <section id="scale" className="stt-section">
            <h2 className="stt-h2">Impute → One-hot → Standardize</h2>
            <PyCell code={exPreprocessScale} />
            <div className="stt-output"><pre>{exPreprocessScaleOut}</pre></div>
          </section>
        </article>
      </div>
    </main>
  );
}
